import {
  getCurrentLocalDateTime,
  leapYear,
  months,
  pad,
} from "./getLocalDateTime";
import _ from "lodash";

const getMonthDays = (monthIndex, year) => {
  if (monthIndex === 1) {
    return leapYear(year) ? 29 : 28;
  }
  return months[monthIndex].days;
};

const convertTimeToDate = (isoDateTime) => {
  const splitDate = String(isoDateTime).split("T");
  if (splitDate.length > 0) {
    return splitDate[0];
  }
  return isoDateTime;
};

export const cal_new_installment = (
  data,
  number_period,
  paid_date = new Date(),
  interest_rate,
  type
) => {
  let new_installments = [];
  let today = getCurrentLocalDateTime(new Date(paid_date));
  let capitalRemain = data.capitalRemain;
  let last_installment = data.installments[data.installments.length - 1];
  let last_installment_datetime = getCurrentLocalDateTime(
    new Date(last_installment.date)
  );

  let currnt_month_index = last_installment_datetime.monthIndex;
  for (let index = 0; index < number_period; index++) {
    let plus_mounth = 0;
    if (index === 0) {
      plus_mounth = 1;
    }
    let new_date_installment = new Date(last_installment_datetime.fullDate);
    new_date_installment.setMonth(
      new_date_installment.getMonth() + index + plus_mounth
    );

    const new_date_local = getCurrentLocalDateTime(
      new Date(new_date_installment)
    );

    // ใช้จำนวนวันของเดือนก่อนหน้าในการคำนวณดอกเบี้ย
    let prevMonthIndex = new_date_local.monthIndex - 1;
    let prevYear = new_date_local.year;
    if (prevMonthIndex < 0) {
      prevMonthIndex = 11;
      prevYear = prevYear - 1;
    }
    const days = getMonthDays(prevMonthIndex, prevYear);

    const filter_interest_rate = interest_rate.filter((rate) => {
      return rate.type === type;
    });

    const interest_rate_value = filter_interest_rate[0].value;

    const interest =
      ((capitalRemain * (interest_rate_value / 100)) / 365) * days;

    const new_installment = {
      disabledPeriod: false,
      newInstallmentStatus: "created",
      isNewInstallment: true,
      isNewInstallmentDate: today.isoDateTime,
      actualInterest: Math.ceil(Number(interest)),
      planInterest: Math.ceil(Number(interest)),
      actualPrinciple: 0,
      planCapitalRemain: capitalRemain,
      actualCapitalRemain: capitalRemain,
      planPrinciple: 0,
      receiveInterest: 0,
      interestMore: 0,
      days: days,
      date: new_date_local.fullDate,
      paid_interest_more: false,
      paid_date: "-",
      paid_amount: 0,
      paid_amount_interest_more: 0,
      overflow: 0,
      paid_overflow: false,
      paid_interest: false,
      penalty: 0,
    };

    currnt_month_index = new_date_installment.getMonth();
    new_installments.push(new_installment);
  }

  return _.cloneDeep(new_installments);
};

export const calcuratorInterestTwo = (loan, { where, dataInterest }) => {
  // const today = getCurrentLocalDateTime(new Date(where.paid_date));
  const today = getCurrentLocalDateTime(new Date(where.paid_date));

  // console.log("calcuratorInterestTwo today", today)

  let newItem = { ...loan };
  const {
    installments: oriInstallments,
    type,
    promo: loanPromo = 0,
    capitalRemain,
    initCapital,
    interestMore = 0,
    overflow,
    evidence = [],
  } = newItem;
  let installments = oriInstallments;
  let newInterestMore = 0;
  let newPrincipleMore = 0;
  let checkPrincipleMore = false;
  let checkInterestMore = false;
  let checkOverflow = false;
  let checkCapital = false;
  let newCapital = initCapital;
  let lastIndex = installments.length - 1;
  let prevOverflow = 0;
  let cal_index = 0;
  let total_penalty = 0;
  let check_penalty = false;
  let last_penalty = 0;
  let total_late = 0;
  let check_late = false;
  let total_penalty_all = 0;

  let keep_penalty = 0;
  let keep_late = 0;
  let keep_late_interest = 0;
  let self_keep_late = 0;
  let self_keep_late_interest = 0;
  let last_keep_late = 0;
  let last_add_penalty = 0;
  let check_last_penalty = false;
  let stack_penalty = [];
  let keep_overflow = 0;

  let cal_capital_overflow = initCapital;
  let check_remain = false;

  for (let index = installments.length - 1; index >= 0; index--) {
    const installment = installments[index];
    if (installment.isNewInstallment && installment.actualCapitalRemain > 0) {
      installment.planCapitalRemain = installment.actualCapitalRemain;
    }
  }

  if (overflow > 0) {
    // console.log("in overflow", overflow);
    for (let index = installments.length - 1; index >= 0; index--) {
      // วนลูปจากงวดท้าย
      const last_installment = installments[index]; // ค่างวดล่าสุด
      let principle_remain = last_installment.actualCapitalRemain - overflow; // หาเงินต้นจากการโปะ
      let checkPeriod = today.fullDate <= last_installment.date;

      if (
        last_installment.disabledPeriod &&
        last_installment.paid_amount === 0
      ) {
        if (principle_remain < 0) {
          last_installment.planCapitalRemain = 0;
        }
      }

      if (
        !last_installment.disabledPeriod &&
        checkPeriod &&
        last_installment.paid_amount === 0
      ) {
        if (principle_remain < 0) {
          last_installment.planCapitalRemain = 0;
        } else {
          last_installment.planCapitalRemain = principle_remain;
        }
      }
    }
  }

  for (let index = 0; index < installments.length; index++) {
    let installment = installments[index];

    let INTEREST_RATE_TYPE = dataInterest.Items.find(
      (item) => item.type === type
    );

    const promo = loanPromo || 0;
    let INTEREST_PROMO = +INTEREST_RATE_TYPE.value + promo;
    let INTEREST_RATE = +INTEREST_PROMO < 15 ? 15 / 100 : +INTEREST_PROMO / 100;

    let checkDate = today.fullDate > installment.date;
    let checkPeriod = today.fullDate <= installment.date;

    let prevIndex = index === 0 ? 0 : index - 1;

    let total_period = installment.actualInterest + installment.actualPrinciple;
    if (installment.disabledPeriod && total_period === 0) {
      cal_index++;
    }

    let total_plan = installment.planPrinciple + installment.planInterest;
    let prev_total_plan =
      installments[prevIndex].planPrinciple +
      installments[prevIndex].planInterest;
    let total_actual = installment.actualPrinciple + installment.actualInterest;

    // if (installment.actualPrinciple > installment.planPrinciple) {
    //   let cal_actual_principle =
    //     installment.actualPrinciple - installment.planPrinciple;
    //   installment.actualPrinciple = installment.planPrinciple;
    //   let prevIndex = index;
    //   do {
    //     prevIndex--;
    //     if (prevIndex < 0) {
    //       break;
    //     }

    //     if (cal_actual_principle > 0) {
    //       if (cal_actual_principle >= installments[prevIndex].planPrinciple) {
    //         installments[prevIndex].actualPrinciple =
    //           installments[prevIndex].planPrinciple;
    //       } else {
    //         installments[prevIndex].actualPrinciple = cal_actual_principle;
    //       }
    //       cal_actual_principle -= installments[prevIndex].planPrinciple;
    //     }
    //   } while (cal_actual_principle > 0);
    // }

    // if (installment.interestMore > 0) {
    //   let cal_actual_interest = installment.interestMore;
    //   let prevIndex = index;
    //   do {
    //     prevIndex--;
    //     if (prevIndex < 0) {
    //       break;
    //     }

    //     if (cal_actual_interest > 0) {
    //       if (cal_actual_interest > installment.planInterest) {
    //         // console.log("1");
    //         installments[prevIndex].actualInterest = installment.planInterest;
    //       } else {
    //         installments[prevIndex].actualInterest = cal_actual_interest;
    //       }
    //       cal_actual_interest -= installments[prevIndex].planInterest;
    //     }
    //   } while (cal_actual_interest > 0);
    // }

    let {
      paid_amount: prev_paid_amount,
      planPrinciple: prevPlanPrinciple,
      planInterest: prevPlanInterest,
      planCapitalRemain: prevPlanCapitalRemain,
      penalty: prevPenalty,
      overflow: prevOverflow,
      disabledPeriod: prevDisablePeriod,
      interestMore: prevInterestMore,
      actualInterest: prevActualInterest,
      actualPrinciple: prevActualPrinciple,
      isPenalty: prevIsPenalty = false,
      isLastAddPenalty: prevIsLastAddPenalty = false,
    } = installments[prevIndex];

    let nextIndex = index + 1 < installments.length ? index + 1 : index;

    newCapital = prevPlanCapitalRemain - installment.planPrinciple;

    if (overflow > 0) {
      // console.log("in overflow", overflow);
      // console.log("keep_overflow", keep_overflow);
    }

    if (checkDate && !installment.disabledPeriod) {
      installment.disabledPeriod = true;
      if (installment.paid_amount === 0) {
        newCapital = capitalRemain;
      } else {
        // console.log("enabled");
        newCapital = installment.planCapitalRemain;
      }
    } else {
      if (!checkCapital && checkPeriod && !installment.disabledPeriod) {
        if (installment.paid_amount > 0) {
          newCapital = installment.planCapitalRemain;
        } else {
          newCapital = capitalRemain;
        }
        checkCapital = true;
      } else {
        if (!installment.disabledPeriod) {
          newCapital = installment.planCapitalRemain - keep_overflow;
        } else {
          newCapital = installment.planCapitalRemain;
        }
      }
    }

    if (installment.date > checkPeriod) {
      newCapital = installment.planCapitalRemain - keep_overflow;
    }

    if (
      installment.disabledPeriod &&
      installment.actualPrinciple + installment.actualInterest > 0
    ) {
      installment.displayStatus = "ค้างชำระ";
    }

    // console.log("----------------------------------");

    if (newCapital < 0) {
      newCapital = 0;
    }

    if (installment.planCapitalRemain === 0) {
      newCapital = 0;
    }

    // สำหรับงวดงอก ให้ใช้ actualCapitalRemain ในการคำนวณ planCapitalRemain และ planInterest
    // if (installment.isNewInstallment && installment.actualCapitalRemain > 0) {
    //   newCapital = installment.actualCapitalRemain;
    // }

    installment.planCapitalRemain = newCapital;

    let interest = ((newCapital * INTEREST_RATE) / 365) * installment.days;
    installment.planInterest = Math.ceil(Number(interest));
    //   if (installment.paid_interest) {
    //     installment.actualInterest = Math.ceil(
    //       Number(installment.actualInterest)
    //     );
    //   }
    if (
      !installment.paid_interest &&
      installment.actualInterest === 0 &&
      installment.disabledPeriod
    ) {
      installment.actualInterest = 0;
      installment.paid_interest = true;
    }

    if (!installment.paid_interest) {
      installment.actualInterest = Math.ceil(Number(interest));
    } else if (
      installment.paid_amount > 0 ||
      installment.overflow ||
      installment.actualInterest === 0
    ) {
      installment.actualInterest = installment.actualInterest;
    }

    //  else {
    //     installment.actualInterest = installment.actualInterest;
    //   }
  }

  let countDisabled = 0;
  installments.forEach((installment) => {
    let checkPeriod = today.fullDate <= installment.date;

    if (installment.disabledPeriod) {
      countDisabled++;
      if (countDisabled !== installments.length) {
        newInterestMore += installment.actualInterest;
      }
    }

    if (checkPeriod && !checkInterestMore) {
      installment.interestMore = newInterestMore;
      checkInterestMore = true;
    }
  }, 0);

  if (countDisabled === installments.length) {
    installments[installments.length - 1].interestMore = newInterestMore;
  }

  // console.log("newInterestMore", newInterestMore);

  newItem.interestMore = newInterestMore;
  return newItem;
};

export const calcuratorInterest = (loan, { where, dataInterest }) => {
  const today = getCurrentLocalDateTime(new Date(where.paid_date));
  let newItem = { ...loan };
  const {
    installments,
    type,
    promo: loanPromo = 0,
    capitalRemain,
    initCapital,
    interestMore = 0,
    overflow,
  } = newItem;
  let newInterestMore = interestMore;
  let newPrincipleMore = 0;
  let checkPrincipleMore = false;
  let checkInterestMore = false;
  let checkCapital = false;
  let newCapital = initCapital;
  let lastIndex = installments.length - 1;
  for (let index = 0; index < installments.length; index++) {
    let installment = installments[index];

    let INTEREST_RATE_TYPE = dataInterest.Items.find(
      (item) => item.type === type
    );

    const promo = loanPromo || 0;
    let INTEREST_PROMO = +INTEREST_RATE_TYPE.value + promo;
    let INTEREST_RATE = +INTEREST_PROMO < 15 ? 15 / 100 : +INTEREST_PROMO / 100;

    let checkDate = today.fullDate > installment.date;

    if (checkDate && !installment.disabledPeriod) {
      installment.disabledPeriod = true;
    }

    let {
      paid_amount,
      principleRemain,
      planCapitalRemain,
      planPrinciple,
      actualPrinciple,
      actualInterest,
      disabledPeriod,
      paid_interest_more,
    } = installment;

    if (index === 0) {
      newCapital = initCapital;
    }

    const prevIndex = index - 1;
    if (index > 0) {
      const {
        overflow: prevOverflow,
        disabledPeriod: prevDisabledPeriod,
        planPrinciple: prevPlanPrinciple,
        planCapitalRemain: prevPlanCapitalRemain,
        actualCapitalRemain: prevActualCapitalRemain,
        actualPrinciple: prevActualPrinciple,
        actualInterest: prevActualInterest,
        interestMore: prevInterestMore,
        paid_interest_more: prev_paid_interest_more,
        planInterest: prevPlanInterest,
        paid_interest: prevPaidInterest,
        paid_principle: prevPaidPrinciple,
        paid_amount: prevPaidAmount,
        penalty: prevPenalty,
      } = installments[prevIndex];

      const checkPrinciple = prevActualPrinciple !== 0 && prevDisabledPeriod;
      const checkInterest = prevActualInterest !== 0 && prevDisabledPeriod;

      if (checkPrinciple) {
        newPrincipleMore += prevActualPrinciple;
        installments[prevIndex].actualPrinciple = 0;
        if (
          disabledPeriod &&
          installments[index + 1 === installments.length ? index : index + 1]
            .disabledPeriod
        ) {
          installment.actualPrinciple =
            installment.actualPrinciple + newPrincipleMore;
        }
        if (prevPaidAmount === 0) {
          installments[prevIndex].planCapitalRemain = capitalRemain;
        }
      }

      if (checkInterest) {
        newInterestMore += prevActualInterest;
        if (prevInterestMore > 0) {
          newInterestMore = prevInterestMore + prevActualInterest;
        }
        installments[prevIndex].actualInterest = 0;
        installments[prevIndex].interestMore = 0;
        checkInterestMore = false;
      }

      newCapital =
        prevActualPrinciple !== 0 || prevActualInterest !== 0
          ? prevPlanCapitalRemain
          : planCapitalRemain - prevOverflow;

      if (installment.paid_overflow) {
        newCapital = 0;
      }

      if (!disabledPeriod) {
        newCapital = prevPlanCapitalRemain - prevPlanPrinciple;
        if (newInterestMore > 0) {
          newCapital = prevPlanCapitalRemain - prevPlanPrinciple - prevPenalty;
        }

        if (!checkCapital) {
          if (overflow > 0 || paid_interest_more) {
            newCapital = capitalRemain;
          }
          checkCapital = true;
        }
      }

      if (!disabledPeriod && !checkPrincipleMore && checkPrinciple) {
        newCapital = capitalRemain;
        installment.actualPrinciple += newPrincipleMore;
        installment.penalty = newPrincipleMore;
        // installment.planPrinciple += newPrincipleMore;
        checkPrincipleMore = true;
      }

      if (
        (!disabledPeriod || index === installments.length - 1) &&
        !checkInterestMore &&
        checkInterest
      ) {
        checkInterestMore = true;
        if (!paid_interest_more) {
          installment.interestMore = newInterestMore;
        }
        newInterestMore = installment.interestMore;
      }

      if (!disabledPeriod && prev_paid_interest_more && !prevDisabledPeriod) {
        newCapital = prevPlanCapitalRemain - prevActualPrinciple;
        if (prevPaidAmount !== 0) {
          newCapital =
            prevPlanCapitalRemain -
            prevPenalty -
            prevPlanPrinciple -
            prevOverflow;
        }
      }

      // const { disabledPeriod: lastDisabledPeriod } = installments[lastIndex];

      // if (lastDisabledPeriod) {
      //   newItem.installments[lastIndex].interestMore = 0;
      //   lastIndex--;
      // }
      // if (!lastDisabledPeriod && !checkInterestMore) {
      //   // newItem.installments[lastIndex - 1].interestMore = 0;
      //   newItem.installments[lastIndex].interestMore = newInterestMore;
      //   checkInterestMore = true;
      // }
    }

    let interest = ((newCapital * INTEREST_RATE) / 365) * installment.days;
    installment.planInterest =
      installment.paid_interest || installment.paid_overflow
        ? installment.planInterest
        : Math.ceil(Number(interest));

    if (installment.paid_interest || installment.paid_overflow) {
      installment.actualInterest = Math.ceil(
        Number(installment.actualInterest)
      );
    } else if (newCapital !== installment.planCapitalRemain) {
      installment.actualInterest = Math.ceil(Number(interest));
    }
    // installment.actualInterest = installment.paid_interest
    //   ? installment.actualInterest
    //   : installment.planInterest;
    // installment.planInterest = disabledPeriod
    //   ? installment.planInterest
    //   : Math.ceil(Number(interest));
    // installment.actualInterest =
    //   installment.paid_interest || installment.paid_overflow
    //     ? installment.actualInterest
    //     : Math.ceil(Number(interest));
    installment.planCapitalRemain =
      installment.paid_amount > 0 ? planCapitalRemain : newCapital;
  }

  newItem.interestMore = installments.reduce((prev, installment) => {
    return prev + installment.interestMore;
  }, 0);

  return newItem;
};

export const calTempInstallments = (data, interest) => {
  let completedAt = getCurrentLocalDateTime(new Date(data.requestTime)).date;
  let promo = 0;
  if (data.promo != undefined) promo = +data.promo;
  let initCapital = data.requestamount;
  let capital = initCapital;
  let installments = [];
  let tempNewInstallment = _.cloneDeep(
    data.installments.filter((installment) => installment.isNewInstallment)
  );

  let INTEREST_RATE_TYPE = interest.Items.find(
    (item) => item.type === data.type
  );

  promo = +promo || 0;
  let INTEREST_PROMO = +INTEREST_RATE_TYPE.value + promo;
  let INTEREST_RATE = +INTEREST_PROMO < 15 ? 15 / 100 : +INTEREST_PROMO / 100;

  // console.log("INTEREST_RATE", INTEREST_RATE);

  let now = new Date(data.requestTime);
  let principle = Math.ceil(initCapital / data.period);
  let today = getCurrentLocalDateTime(now);
  let nextIndex = today.monthIndex + 1 === 12 ? 0 : today.monthIndex + 1;
  let nextYear = nextIndex === 0 ? today.year + 1 : today.year;
  let checkNextDate = getMonthDays(nextIndex, nextYear) - +today.date < 0;
  let nextDateTime = getCurrentLocalDateTime(
    new Date(
      nextYear,
      today.monthIndex + 1,
      checkNextDate ? getMonthDays(nextIndex, nextYear) : today.date
    )
  );
  let year = nextYear;
  let currentMonthIndex = today.monthIndex;
  let monthIndex = nextDateTime.monthIndex;
  for (let i = 0; i < data.period; i++) {
    if (monthIndex === 12) {
      monthIndex = 0;
      currentMonthIndex = 11;
      year += 1;
    }
    if (currentMonthIndex === 12) {
      currentMonthIndex = 0;
    }

    let currentMonthDays = getMonthDays(currentMonthIndex, year);
    let monthIndexDays = getMonthDays(monthIndex, year);

    let interest = ((+capital * INTEREST_RATE) / 365) * currentMonthDays;

    let currentDate = +completedAt;
    if (currentDate > monthIndexDays) {
      currentDate -= +completedAt - monthIndexDays;
    }
    let principleRemain = Math.abs(principle - capital - principle);
    let checkCapital = i === data.period - 1;
    let originalPrinciple = principle;
    principle = checkCapital ? principleRemain : principle;

    installments.push({
      actualInterest: Math.ceil(Number(interest)),
      planInterest: Math.ceil(Number(interest)),
      actualPrinciple: Math.ceil(Number(principle)),
      planCapitalRemain: Math.ceil(Number(capital)),
      actualCapitalRemain: Math.ceil(Number(capital)),
      planPrinciple: Math.ceil(Number(principle)),
      days: currentMonthDays,
      date: `${year}-${pad(monthIndex + 1)}-${pad(currentDate)}`,
      paid_date: "-",
      paid_amount: 0,
      overflow: 0,
      receiveInterest: 0,
      disabledPeriod: false,
      paid_interest: false,
    });
    capital = capital - principle;
    currentMonthIndex++;
    monthIndex++;
  }

  tempNewInstallment = _.cloneDeep(
    tempNewInstallment.map((installment) => {
      return {
        ...installment,
        disabledPeriod: false,
        paid_interest: false,
        paid_amount: 0,
        actualInterest: installment.planInterest,
        actualPrinciple: installment.planPrinciple,
      };
    })
  );

  return _.cloneDeep(installments.concat(tempNewInstallment));
};

const updateInstallmentsTwo = (
  installments = [],
  {
    paid_amount: paid_amountRaw = 0,
    overflow,
    capitalRemain,
    paid_date,
    phone_number,
    interestMore,
    period,
    requestamount,
    loan_status,
    loan,
    interest,
  }
) => {
  const today = getCurrentLocalDateTime(new Date(paid_date));
  let updateOverflow = Math.ceil(overflow);

  let updateInstallments = [...installments];
  let updateCapitalRemain = +capitalRemain;
  let updateInterestMore = interestMore;
  let checkOverdue = false;
  let overdueDate = "";
  let rawPaidAmount = paid_amountRaw;
  let paid_amount = paid_amountRaw;
  let currentInstallment = installments[0];
  let currentPriciple = installments[0].planPrinciple;
  let currentPeriod = installments.every(
    (installment) => installment.disabledPeriod
  )
    ? installments.length
    : 1;
  let paidAmountInterestMore = 0;
  let updated_paid_interest = 0;
  let updated_paid_principle = 0;
  let updated_paid_interestMore = 0;
  let updated_paid_overflow = 0;
  let paid_amount_remain = paid_amount;
  let installmentNumber = "";
  let relate_period = [];
  // let checkOverflow = false

  // เช็คและสร้างงวดงอกก่อนจ่ายเงิน
  if (loan && interest && updateInstallments.length > 0) {
    // หางวดเดิมล่าสุด (ไม่ใช่งวดงอก) เพื่อใช้ในการคำนวณ
    const originalInstallments = updateInstallments.filter(
      (inst) => !inst.isNewInstallment
    );
    const lastOriginalInstallment =
      originalInstallments[originalInstallments.length - 1];

    // ถ้าไม่มีงวดเดิม ให้ใช้งวดล่าสุดทั้งหมด
    const lastInstallment =
      updateInstallments[updateInstallments.length - 1] ||
      lastOriginalInstallment;
    const lastDate = new Date(lastInstallment.date);
    const convLastDate = getCurrentLocalDateTime(lastDate);

    const totalInterestMore = updateInstallments.reduce((prev, installment) => {
      return prev + installment.actualInterest;
    }, 0);

    // เช็คว่ายังมีเงินต้นเหลืออยู่
    if (updateCapitalRemain + totalInterestMore > 0) {
      // ใช้ paid_date ในการคำนวณ
      const paidDateObj = new Date(paid_date);
      const paidDateLocal = getCurrentLocalDateTime(paidDateObj);

      // เช็คว่าวันที่จ่ายเงินเลยงวดสุดท้ายไปแล้วหรือไม่
      const shouldCreateNewInstallment =
        paidDateLocal.fullDate > convLastDate.fullDate;

      if (shouldCreateNewInstallment) {
        // คำนวณจำนวนงวดที่ควรจะงอกจากความแตกต่างของเดือนระหว่างวันที่จ่ายเงินกับงวดล่าสุด
        const lastDateObj = new Date(convLastDate.fullDate);

        // คำนวณ diff ของเดือนจากวันที่จ่ายเงิน
        const yearDiff = paidDateLocal.year - lastDateObj.getFullYear();
        const monthDiff = paidDateLocal.monthIndex - lastDateObj.getMonth();
        let totalMonthDiff = yearDiff * 12 + monthDiff;

        if (paidDateLocal.date > lastDateObj.getDate()) {
          totalMonthDiff += 1;
        }

        // จำนวนงวดที่ควรจะงอก = diff ของเดือน (ต้องสร้างงวดใหม่ทุกเดือนที่เลยไป)
        const numberOfPeriodsToCreate = totalMonthDiff > 0 ? totalMonthDiff : 1;

        // เช็คว่ามีงวดงอกอยู่แล้วหรือยัง (เช็ค isNewInstallment)
        const existingNewInstallments = updateInstallments.filter(
          (inst) => inst.isNewInstallment
        );

        // หางวดงอกล่าสุดเพื่อเช็คว่าครอบคลุมถึงวันที่จ่ายเงินหรือยัง
        let lastNewInstallmentDate = null;
        if (existingNewInstallments.length > 0) {
          const lastNewInstallment =
            existingNewInstallments[existingNewInstallments.length - 1];
          lastNewInstallmentDate = new Date(lastNewInstallment.date);
        }

        // เช็คว่าต้องสร้างงวดงอกเพิ่มหรือไม่
        const needToCreate =
          !lastNewInstallmentDate ||
          paidDateLocal.fullDate >
            getCurrentLocalDateTime(lastNewInstallmentDate).fullDate;

        // ถ้ายังไม่มีงวดงอก หรือมีน้อยกว่าที่ควรจะมี หรือยังไม่ครอบคลุมถึงวันที่จ่ายเงิน ให้สร้างเพิ่ม
        if (numberOfPeriodsToCreate > 0) {
          const loanData = {
            ...loan,
            installments: updateInstallments,
            capitalRemain: updateCapitalRemain,
          };

          // สร้างงวดงอกตามจำนวนที่ควรจะมี (ลบจำนวนที่มีอยู่แล้วออก)
          const periodsToCreate = numberOfPeriodsToCreate;

          // วน loop สร้างงวดงอกทีละงวด
          for (let i = 0; i < periodsToCreate; i++) {
            // อัพเดท loanData.installments ก่อนเรียก cal_new_installment เพื่อให้ใช้ last_installment ที่ถูกต้อง
            loanData.installments = updateInstallments;

            const new_installments = cal_new_installment(
              loanData,
              1,
              paid_date,
              interest.Items,
              loan.type
            );

            if (new_installments && new_installments.length > 0) {
              updateInstallments = updateInstallments.concat(new_installments);
            }
          }
        }
      }
    }
  }

  // console.log("installments", installments);

  for (let index = 0; index < updateInstallments.length; index++) {
    const installment = _.cloneDeep(updateInstallments[index]);

    let check_paid_principle = false;
    let check_paid_interest = false;

    let checkPeriod = today.fullDate <= installment.date;
    updateInstallments[index].interestMore = 0;

    let receiveInterest = 0;
    if (installment.actualInterest > 0 && paid_amount_remain > 0) {
      paid_amount_remain -= installment.actualInterest;
      check_paid_interest = true;

      if (paid_amount_remain < 0) {
        receiveInterest =
          installment.actualInterest - Math.abs(paid_amount_remain);
        installment.actualInterest = Math.abs(paid_amount_remain);
      } else {
        receiveInterest = installment.actualInterest;
        installment.actualInterest = 0;
      }

      updateInstallments[index].receiveInterest += receiveInterest;
      updateInstallments[index].actualInterest = installment.actualInterest;
      updateInstallments[index].paid_interest = true;
      if (installment.disabledPeriod) {
        updated_paid_interestMore += receiveInterest;
      } else {
        updated_paid_interest += receiveInterest;
      }
    }

    let receivePrinciple = 0;
    if (installment.actualPrinciple > 0 && paid_amount_remain > 0) {
      paid_amount_remain -= installment.actualPrinciple;
      check_paid_principle = true;
      if (paid_amount_remain < 0) {
        receivePrinciple =
          installment.actualPrinciple - Math.abs(paid_amount_remain);
        installment.actualPrinciple = Math.abs(paid_amount_remain);
      } else {
        receivePrinciple = installment.actualPrinciple;
        installment.actualPrinciple = 0;
      }
      updateCapitalRemain -= receivePrinciple;
      updated_paid_principle += receivePrinciple;
      updateInstallments[index].actualCapitalRemain = updateCapitalRemain;
      updateInstallments[index].actualPrinciple = installment.actualPrinciple;
    }

    if (
      installment.actualPrinciple === 0 &&
      installment.actualInterest === 0 &&
      !checkPeriod &&
      installment.displayStatus !== "ปิด-ตรงเวลา"
    ) {
      updateInstallments[index].displayStatus = "ปิด-เลท";
    }

    if (check_paid_interest || check_paid_principle) {
      installmentNumber += `${pad(index + 1)},`;
      relate_period.push(`${pad(index + 1)}`);
    }

    if (checkPeriod) {
      currentInstallment = updateInstallments[index];
      currentPeriod = index + 1;
      const prevIndex = index - 1;
      const checkOverflow = paid_amount_remain > 0;
      const newOverflow = paid_amount_remain;
      let checkUpdate = false;

      updateInstallments[index].paid_date = paid_date;
      updateInstallments[index].paid_amount += paid_amount;

      if (
        installment.actualInterest === 0 &&
        installment.actualPrinciple === 0
      ) {
        updateInstallments[index].disabledPeriod = true;
        updateInstallments[index].displayStatus = "ปิด-ตรงเวลา";
      }

      let nextPrinciple = 0;
      if (checkOverflow) {
        let indeXOverflow = index;
        updateCapitalRemain -= newOverflow;
        updateInstallments[indeXOverflow].paid_overflow = true;
        updateInstallments[indeXOverflow].overflow += newOverflow;
        updateOverflow += +newOverflow;
        updated_paid_overflow += +newOverflow;

        for (let jedex = updateInstallments.length - 1; jedex > 0; jedex--) {
          let lastInstallment = updateInstallments[jedex]; //ดึงตัวสุดท้าย
          let lastPrinciple =
            lastInstallment.actualPrinciple -
            (nextPrinciple < 0
              ? Math.abs(nextPrinciple)
              : Math.floor(newOverflow)); //ถ้าเงินต้นลบ overflow แล้วน้อยกว่า 0 จะดึง nextPrinciple ไปลบงวดย้อนถัดไป ถ้าไม่ใช่จะลบ overflow ปกติและตำแหน่งเดิมของงวดท้ายนั้น

          if (lastInstallment.disabledPeriod) {
            continue;
          }

          if (!checkPeriod) {
            // console.log("break");
            break;
          }

          installmentNumber += `${pad(jedex + 1)},`;
          relate_period.push(`${pad(index + 1)}`);

          if (lastPrinciple === 0) {
            //ถ้าตัวสุดท้ายเหลือ 0
            // console.log("1");
            updateInstallments[jedex].disabledPeriod = true;
            updateInstallments[jedex].actualPrinciple = 0;
            updateInstallments[jedex].planCapitalRemain = 0;
            updateInstallments[jedex].displayStatus = "ปิด-โปะ";
            updateInstallments[jedex].actualInterest = 0;
            updateInstallments[jedex].paid_overflow = true;
            updateInstallments[jedex].planInterest = 0;
            break;
          } else if (lastPrinciple > 0) {
            //มากกว่า 0 break หยุด loop
            // console.log("2");
            updateInstallments[jedex].actualPrinciple =
              Math.floor(lastPrinciple);
            // updateInstallments[jedex].planCapitalRemain =
            //   Math.floor(lastPrinciple);
            break;
          } else if (lastPrinciple < 0) {
            //น้อยกว่า 0 loop รอบถัดไป เช่น งวด 12 > 11
            updateInstallments[jedex].disabledPeriod = true;
            updateInstallments[jedex].actualPrinciple = 0;
            updateInstallments[jedex].actualInterest = 0;
            updateInstallments[jedex].displayStatus = "ปิด-โปะ";
            updateInstallments[jedex].planCapitalRemain = 0;
            updateInstallments[jedex].paid_overflow = true;
            updateInstallments[jedex].planInterest = 0;
            nextPrinciple = Math.floor(lastPrinciple);
          }
        }
      }
      break;
    }
  }

  const includeCapitalRemainOverflow = updateCapitalRemain + updateOverflow;

  let installmentDateIndex = Math.round(
    (requestamount - includeCapitalRemainOverflow) / currentPriciple
  );

  let realInstallmentIndex =
    installmentDateIndex >= installments.length
      ? installments.length - 1
      : installmentDateIndex;

  if (updateCapitalRemain === 0) {
    realInstallmentIndex += 1;
    if (realInstallmentIndex >= installments.length) {
      realInstallmentIndex = installments.length - 1;
    }
  }

  // console.log("updateCapitalRemain", updateCapitalRemain);
  // console.log("updateOverflow", updateOverflow);
  // console.log("includeCapitalRemainOverflow", includeCapitalRemainOverflow);
  // console.log("currentPriciple", currentPriciple);
  // console.log("installmentDateIndex", installmentDateIndex);
  // console.log("requestamount", requestamount);

  const lastInstallment = installments[installments.length - 1];
  if (
    lastInstallment.actualPrinciple +
      lastInstallment.actualInterest +
      lastInstallment.interestMore >
    0
  ) {
    const last_total =
      lastInstallment.actualPrinciple +
      lastInstallment.actualInterest +
      lastInstallment.interestMore;
    const cal_last_paid = last_total - lastInstallment.paid_amount;
  }

  overdueDate = installments[realInstallmentIndex].date;

  return {
    updated_paid_interest,
    updated_paid_interestMore,
    updated_paid_principle,
    updated_paid_overflow,
    checkOverdue, //ของเก่า
    overdueDate,
    currentPeriod,
    currentInstallment,
    interestMore: updateInterestMore < 0 ? 0 : updateInterestMore,
    installments: updateInstallments,
    capitalRemain: updateCapitalRemain,
    overflow: +updateOverflow,
    paidAmountInterestMore,
    installmentNumber,
    relate_period,
  };
};

export const reinstallments = (loan, buroDate = "", interest = "") => {
  if (loan.loan_id) {
    let myDate = new Date(buroDate);
    const selectDateLocal = getCurrentLocalDateTime(myDate);

    let tempLoan = _.cloneDeep(loan);

    tempLoan = {
      ...tempLoan,
      overflow: 0,
      overdue_date: loan?.installments[0]?.date,
    };

    // console.log("tempLoan", tempLoan);

    // let data = tempLoan;

    // {
    //   "actualCapitalRemain": 12833,
    //   "actualInterest": 0,
    //   "actualPrinciple": 0,
    //   "date": "2021-12-09",
    //   "days": 30,
    //   "disabledPeriod": true,
    //   "displayStatus": "ปิด-เลท",
    //   "interestMore": 0,
    //   "overflow": 0,
    //   "paid_amount": 0,
    //   "paid_amount_interest_more": 0,
    //   "paid_date": "-",
    //   "paid_interest": true,
    //   "paid_interest_more": false,
    //   "paid_overflow": false,
    //   "penalty": 0,
    //   "planCapitalRemain": 14000,
    //   "planInterest": 288,
    //   "planPrinciple": 1167,
    //   "receiveInterest": 0
    //  },

    let tempInstallments = _.cloneDeep(
      calTempInstallments(tempLoan, interest)
    ).filter((installment) => !installment?.isNewInstallment);

    // console.log("tempInstallments", tempInstallments);

    // let tempIsNewInstallments = _.cloneDeep(
    //   tempInstallments.filter((installment) => installment.isNewInstallment)
    // );
    // tempInstallments = tempInstallments.filter(
    //   (installment) => !installment.isNewInstallment
    // );

    // console.log("tempInstallments", JSON.stringify(tempInstallments));
    // console.log("1 tempInstallments", tempInstallments);

    let tempOverdueDate = tempInstallments[0].date;
    let tempOverflow = 0;
    let tempLoanStatus = "ACTIVE";
    let tempCapitalRemain = tempLoan.initCapital;
    let tempPaidDateLatest = "";
    let tempInterestMore = 0;
    let tempEvidence = tempLoan.evidence.sort((a, b) => {
      return a?.paid_date > b.paid_date ? 1 : -1;
    });

    // console.log("tempLoanEvi", tempLoan.evidence);
    // check cal new installment
    let lastInstallment = tempInstallments[tempInstallments.length - 1];
    const lastDate = new Date(lastInstallment.date);
    const newLastDate = lastDate;

    const convLastDate = getCurrentLocalDateTime(lastDate);

    newLastDate.setMonth(newLastDate.getMonth() + 1);
    const convNewLastDate = getCurrentLocalDateTime(newLastDate);

    // console.log(convLastDate.fullDate, convNewLastDate.fullDate);
    // console.log("selectDateLocal", selectDateLocal.fullDate);
    // console.log("lastInstallment", lastInstallment);

    if (
      tempCapitalRemain > 0 &&
      lastInstallment?.disabledPeriod &&
      selectDateLocal.fullDate > convLastDate.fullDate
    ) {
      // const new_installments = cal_new_installment(
      //   loan,
      //   1,
      //   convNewLastDate.fullDate,
      //   interest.Items,
      //   tempLoan.type
      // );
      // console.log("new_installments", new_installments);
    }

    if (tempLoan?.loan_kbank_id === "500534518") {
      tempLoan.evidence[5] = {
        ...tempLoan.evidence[5],
        paid_amount: 5642,
        // paid_date: "2022-01-19T00:00:00+07:00",
      };
    }

    if (tempLoan?.loan_kbank_id === "400019769") {
      // console.log("tempLoan", tempLoan);
      tempLoan.evidence[2] = {
        ...tempLoan.evidence[2],
        paid_date: "2022-01-19T00:00:00+07:00",
      };
    }

    if (tempLoan.loan_kbank_id === "400019377") {
      tempLoan.evidence[3] = {
        ...tempLoan.evidence[3],
        paid_date: "2022-01-18T00:00:00+07:00",
      };
    }

    if (tempLoan.loan_kbank_id === "500065349") {
      tempLoan.evidence[2] = {
        ...tempLoan.evidence[2],
        paid_date: "2022-05-05T00:00:00+07:00",
      };
    }

    if (tempLoan.loan_kbank_id === "400086975") {
      tempLoan.evidence[0] = {
        ...tempLoan.evidence[0],
        paid_date: "2021-12-10T00:00:00+07:00",
      };
    }

    if (tempLoan.loan_kbank_id === "400130405") {
      tempLoan.evidence[0] = {
        ...tempLoan.evidence[0],
        paid_date: "2021-12-29T00:00:00+07:00",
      };
    }

    if (tempLoan.loan_kbank_id === "500109488") {
      tempLoan.evidence[3] = {
        ...tempLoan.evidence[3],
        paid_date: "2022-06-26T00:00:00+07:00",
      };
    }

    if (tempLoan.loan_kbank_id === "500210132") {
      tempLoan.evidence[tempEvidence.length - 1] = {
        ...tempLoan.evidence[tempEvidence.length - 1],
        paid_amount: 911.04,
      };
    }

    if (tempLoan.loan_kbank_id === "500241879") {
      tempLoan.evidence[tempEvidence.length - 1] = {
        ...tempLoan.evidence[tempEvidence.length - 1],
        paid_amount: 56,
      };
    }

    if (tempLoan.loan_kbank_id === "500053196") {
      tempLoan.evidence[tempEvidence.length - 1] = {
        ...tempLoan.evidence[tempEvidence.length - 1],
        paid_amount: 70,
      };
    }

    if (tempLoan.loan_kbank_id === "400038605") {
      tempLoan.evidence[tempEvidence.length - 1] = {
        ...tempLoan.evidence[tempEvidence.length - 1],
        paid_amount: 1358,
      };
    }

    if (tempLoan.loan_kbank_id === "400040444") {
      tempLoan.evidence[tempEvidence.length - 1] = {
        ...tempLoan.evidence[tempEvidence.length - 1],
        paid_amount: 1714.0,
      };
    }

    if (tempLoan.loan_kbank_id === "400135675") {
      tempLoan.evidence[0] = {
        ...tempLoan.evidence[0],
        paid_date: "2021-12-30T00:00:00+07:00",
      };
      tempLoan.evidence[2] = {
        ...tempLoan.evidence[2],
        paid_date: "2022-01-30T00:00:00+07:00",
      };
    }

    if (tempLoan.loan_kbank_id === "400046794") {
      tempLoan.evidence[4] = {
        ...tempLoan.evidence[4],
        paid_date: "2022-01-27T00:00:00+07:00",
      };
      tempLoan.evidence[5] = {
        ...tempLoan.evidence[5],
        paid_date: "2022-02-27T00:00:00+07:00",
      };
    }

    if (tempLoan.loan_kbank_id === "400041293") {
      tempLoan.evidence[1] = {
        ...tempLoan.evidence[1],
        paid_date: "2021-12-27T04:52:00+07:00",
      };
      tempLoan.evidence[2] = {
        ...tempLoan.evidence[2],
        paid_date: "2021-12-27T04:54:00+07:00",
      };
      tempLoan.evidence[3] = {
        ...tempLoan.evidence[3],
        paid_date: "2022-01-27T06:17:00+07:00",
      };
      tempLoan.evidence[4] = {
        ...tempLoan.evidence[4],
        paid_date: "2022-02-27T08:38:00+07:00",
      };
    }

    if (tempLoan.loan_kbank_id === "400042324") {
      tempLoan.evidence[0] = {
        ...tempLoan.evidence[0],
        paid_date: "2021-12-29T00:00:00+07:00",
      };
      tempLoan.evidence[1] = {
        ...tempLoan.evidence[1],
        paid_date: "2021-01-29T00:00:00+07:00",
      };
    }

    if (tempLoan.loan_kbank_id === "400048737") {
      tempLoan.evidence[4] = {
        ...tempLoan.evidence[4],
        paid_date: "2022-03-02T00:00:00+07:00",
      };
    }

    if (tempLoan.loan_kbank_id === "400043753") {
      tempLoan.evidence[tempEvidence.length - 1] = {
        ...tempLoan.evidence[tempEvidence.length - 1],
        paid_amount: 2062,
      };
    }

    if (tempLoan.loan_kbank_id === "400047137") {
      tempLoan.evidence[tempEvidence.length - 1] = {
        ...tempLoan.evidence[tempEvidence.length - 1],
        paid_amount: 2600,
      };
    }

    if (tempLoan.loan_kbank_id === "400048555") {
      tempLoan.evidence[tempEvidence.length - 1] = {
        ...tempLoan.evidence[tempEvidence.length - 1],
        paid_amount: 3490,
      };
    }

    if (tempLoan.loan_kbank_id === "400048741") {
      tempLoan.evidence[tempEvidence.length - 1] = {
        ...tempLoan.evidence[tempEvidence.length - 1],
        paid_amount: 421,
      };
    }

    if (tempLoan.loan_kbank_id === "400048878") {
      tempLoan.evidence[tempEvidence.length - 1] = {
        ...tempLoan.evidence[tempEvidence.length - 1],
        paid_amount: 2636,
      };
    }

    if (tempLoan.loan_kbank_id === "400034312") {
      tempLoan.evidence[tempEvidence.length - 1] = {
        ...tempLoan.evidence[tempEvidence.length - 1],
        paid_amount: 1964,
      };
    }

    if (tempLoan.loan_kbank_id === "600291388") {
      tempLoan.evidence[tempEvidence.length - 1] = {
        ...tempLoan.evidence[tempEvidence.length - 1],
        paid_amount: 1022,
      };
    }

    if (tempLoan.loan_kbank_id === "400111862") {
      tempLoan.evidence[tempEvidence.length - 1] = {
        ...tempLoan.evidence[tempEvidence.length - 1],
        paid_amount: 1715,
      };
    }

    if (tempLoan.loan_kbank_id === "400181853") {
      tempLoan.evidence[tempEvidence.length - 1] = {
        ...tempLoan.evidence[tempEvidence.length - 1],
        paid_amount: 9,
      };
    }

    if (tempLoan.evidence.length > 0) {
      let checkAddNewInstallment = false;
      for (let index = 0; index < tempEvidence.length; index++) {
        const evidence = tempEvidence[index];
        const evidencePaidDateLocal = getCurrentLocalDateTime(
          new Date(evidence.paid_date)
        );
        // const lastInstallment = tempInstallments[tempInstallments.length - 1];

        // const findIsNewInstallment = tempIsNewInstallments.find(
        //   (newInstallment) => newInstallment.date <= evidencePaidDateLocal
        // );

        // if (findIsNewInstallment && !checkAddNewInstallment) {
        //   tempInstallments = tempInstallments.concat(tempIsNewInstallments);
        //   checkAddNewInstallment = true
        // }

        if (
          selectDateLocal.fullDate >= evidencePaidDateLocal.fullDate &&
          evidence.evidence_status === "APPROVE"
        ) {
          let where = {
            paid_date: new Date(evidence.paid_date),
          };
          let dataInterest = interest;
          const calNewLoan = calcuratorInterestTwo(
            {
              ...tempLoan,
              installments: tempInstallments,
              overflow: tempOverflow,
              loan_status: tempLoanStatus,
              capitalRemain: tempCapitalRemain,
              paid_date_latest: tempPaidDateLatest,
              interestMore: tempInterestMore,
              overdue_date: tempOverdueDate,
            },
            {
              where,
              dataInterest,
            }
          );

          tempInstallments = calNewLoan.installments;

          if (loan.loan_kbank_id === "400034857") {
            for (let index = 0; index < tempInstallments.length; index++) {
              if (index === 2 && !tempInstallments[index].disabledPeriod) {
                tempInstallments[index].actualInterest = 121;
                tempInstallments[index].planInterest = 121;
                tempInstallments[index].planCapitalRemain = 4302;
              }
            }
          }

          if (tempLoan.loan_kbank_id === "400079684" && index === 0) {
            tempInstallments[0].actualInterest = 288 + 298;
            tempInstallments[1].actualInterest = 0;
          }

          if (
            tempLoan.loan_kbank_id === "400144429" &&
            tempInstallments?.[44]?.actualInterest > 0
          ) {
            tempInstallments[44].actualInterest = 0;
            tempInstallments[44].planInterest = 0;
          }

          if (tempLoan.loan_kbank_id === "400014942" && index === 0) {
            tempInstallments[0].actualInterest = 206 + 213;
            tempInstallments[1].actualInterest = 0;
            tempInstallments[1].paid_interest = true;
          }

          if (
            tempLoan.loan_kbank_id === "400170943" &&
            tempInstallments?.[15]?.actualInterest > 0
          ) {
            tempInstallments[15].actualInterest = 0;
            tempInstallments[15].paid_interest = true;
          }

          if (tempLoan.loan_kbank_id === "400007734" && index === 0) {
            tempInstallments[0].actualInterest = 107 + 103;
            tempInstallments[1].actualInterest = 0;
            tempInstallments[1].paid_interest = true;
          }

          console.log("index", index);
          console.log("tempInstallments", tempInstallments);
          console.log("-".repeat(100));

          tempInstallments = tempInstallments.map((installment) => {
            return {
              ...installment,
              interestMore: 0,
            };
          });

          let new_installments = updateInstallmentsTwo(tempInstallments, {
            overflow: tempOverflow,
            paid_amount: Number(evidence.paid_amount),
            paid_date: evidencePaidDateLocal.fullDate,
            capitalRemain: tempCapitalRemain,
            phone_number: tempLoan.phone_number,
            interestMore: tempInterestMore,
            period: tempLoan.period,
            requestamount: tempLoan.requestamount,
            loan: tempLoan,
            interest: interest,
          });

          tempCapitalRemain = new_installments.capitalRemain;
          tempInterestMore = new_installments.interestMore;
          tempOverflow = new_installments.overflow;
          tempInstallments = new_installments.installments;
          tempPaidDateLatest = evidence.paid_date;
          tempOverdueDate = new_installments.overdueDate;
        }
      }

      let remainInterest = tempInstallments?.reduce((acc, cur) => {
        return acc + cur.actualInterest;
      }, 0);

      if (tempCapitalRemain + remainInterest <= 0) {
        tempLoanStatus = "DONE";
      }
    }

    const totalInterest = tempInstallments?.reduce((acc, cur) => {
      return acc + cur.actualInterest;
    }, 0);

    // สร้างงวดงอกต่อจากวันที่จ่ายล่าสุดไปจนถึงวันที่เลือก (buroDate) ถ้ายังมีเงินต้นคงค้างอยู่
    if (
      interest &&
      tempInstallments.length > 0 &&
      tempCapitalRemain + totalInterest > 0
    ) {
      // หางวดล่าสุดทั้งหมด (รวมงวดงอก)
      const lastInstallment = tempInstallments[tempInstallments.length - 1];
      const lastDate = new Date(lastInstallment.date);
      const convLastDate = getCurrentLocalDateTime(lastDate);

      // เช็คว่าวันที่เลือก (buroDate) เลยงวดล่าสุดไปแล้วหรือไม่
      if (selectDateLocal.fullDate > convLastDate.fullDate) {
        // คำนวณจำนวนงวดที่ควรจะงอกจากความแตกต่างของเดือนระหว่างวันที่เลือกกับงวดล่าสุด
        const lastDateObj = new Date(convLastDate.fullDate);

        // คำนวณ diff ของเดือนจากวันที่เลือก (buroDate)
        const yearDiff = selectDateLocal.year - lastDateObj.getFullYear();
        const monthDiff = selectDateLocal.monthIndex - lastDateObj.getMonth();
        let totalMonthDiff = yearDiff * 12 + monthDiff;

        if (selectDateLocal.date > lastDateObj.getDate()) {
          totalMonthDiff += 1;
        }

        // จำนวนงวดที่ควรจะงอก = diff ของเดือน (ต้องสร้างงวดใหม่ทุกเดือนที่เลยไป)
        const numberOfPeriodsToCreate = totalMonthDiff > 0 ? totalMonthDiff : 1;

        // สร้างงวดงอกตามจำนวนที่ควรจะมี (ลบจำนวนที่มีอยู่แล้วออก)
        const periodsToCreate = numberOfPeriodsToCreate;

        if (periodsToCreate > 0) {
          const loanData = {
            ...tempLoan,
            installments: tempInstallments,
            capitalRemain: tempCapitalRemain,
          };

          // วน loop สร้างงวดงอกทีละงวด
          for (let i = 0; i < periodsToCreate; i++) {
            // อัพเดท loanData.installments ก่อนเรียก cal_new_installment เพื่อให้ใช้ last_installment ที่ถูกต้อง
            loanData.installments = tempInstallments;

            const new_installments = cal_new_installment(
              loanData,
              1,
              selectDateLocal.fullDate,
              interest.Items,
              tempLoan.type
            );

            if (new_installments && new_installments.length > 0) {
              tempInstallments = tempInstallments.concat(new_installments);
            }
          }
        }
      }
    }

    for (let index = 0; index < tempInstallments.length; index++) {
      const tempInstallment = tempInstallments[index];
      if (tempInstallment.actualPrinciple > 0) {
        tempOverdueDate = tempInstallment.date;
        break;
      }
    }

    if (tempLoan?.loan_kbank_id === "500210132") {
      tempInstallments[tempInstallments.length - 1].paid_amount = "897";
    }

    if (tempLoan.loan_kbank_id === "500241879") {
      tempInstallments[tempInstallments.length - 1].paid_amount = "1084";
    }

    if (tempLoan.loan_kbank_id === "400038605") {
      tempInstallments[tempInstallments.length - 1].paid_amount = "2606";
    }

    if (tempLoan.loan_kbank_id === "400040444") {
      tempInstallments[tempInstallments.length - 2].paid_amount = "1696";
    }

    if (tempLoan.loan_kbank_id === "400043753") {
      tempInstallments[tempInstallments.length - 4].paid_amount = "2606";
    }

    if (tempLoan.loan_kbank_id === "400047137") {
      tempInstallments[tempInstallments.length - 2].paid_amount = "3910";
    }

    if (tempLoan.loan_kbank_id === "400048555") {
      tempInstallments[tempInstallments.length - 4].paid_amount = "4323";
    }

    if (tempLoan.loan_kbank_id === "500692182" && buroDate === "2024-05-31") {
      tempInstallments[tempInstallments.length - 1].actualInterest = 1;
    }

    // console.log("tempInstallments", tempInstallments);

    // if (tempLoan.loan_kbank_id === "500241879") {
    // tempInstallments[9].actualCapitalRemain = "0";
    // tempInstallments[9].actualInterest = "0";
    // tempInstallments[9].actualPrinciple = "0";
    // tempInstallments[9].planInterest = "0";
    // tempInstallments[9].planPrinciple = "0";
    // }

    // console.log("tempOverdueDate", tempOverdueDate);

    // const calNewLoan = calcuratorInterestTwo(
    //   {
    //     ...tempLoan,
    //     installments: tempInstallments,
    //     overflow: tempOverflow,
    //     loan_status: tempLoanStatus,
    //     capitalRemain: tempCapitalRemain,
    //     paid_date_latest: tempPaidDateLatest,
    //     interestMore: tempInterestMore,
    //     overdue_date: tempOverdueDate,
    //   },
    //   {
    //     where: { paid_date: new Date(buroDate) },
    //     dataInterest: interest,
    //   }
    // );

    // console.log("calNewLoan", calNewLoan);

    // console.log("tempCapitalRemain", tempCapitalRemain)

    return {
      installments: tempInstallments,
      overflow: tempOverflow,
      loan_status: tempLoanStatus,
      capitalRemain: tempCapitalRemain,
      paid_date_latest: tempPaidDateLatest,
      interestMore: tempInterestMore,
      overdue_date: tempOverdueDate,
    };
  }
};
